import { render, staticRenderFns } from "./giftHistory.vue?vue&type=template&id=190829b0&scoped=true"
import script from "./giftHistory.vue?vue&type=script&lang=js"
export * from "./giftHistory.vue?vue&type=script&lang=js"
import style0 from "./giftHistory.vue?vue&type=style&index=0&id=190829b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190829b0",
  null
  
)

export default component.exports